import moment from 'moment-jalaali';
export function nestadDataFormatter(cell, row,field) {
    //console.log(cell[field]);
    
    return cell!=null ? cell[field]:'';

  }

export  function enumDataFormatter(cell, row,enumObject) {
    //console.log(cell[field]);
    
    return cell!=null ? enumObject[cell]:'';

  }

export  function dateDataFormatter(cell, row) {
    //console.log(moment(cell).format('jYYYY/jM/jD'));
    
    return moment(cell).isValid() ? moment(cell).format('jYYYY/jMM/jDD'):'';

  }

  export  function dateDataTimeFormatter(cell, row) {
    //console.log(moment(cell).format('jYYYY/jM/jD'));
    
    return moment(cell).isValid() ? moment(cell).format('jYYYY/jMM/jDD HH:mm:ss'):'';

  }  

export  const rightAlignStyle = {
   
    textAlign: 'right'
  };
